import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  productionenvironment: boolean = true;
  urlService: String = "";
  urlHome: String = "";
  urlSIIGOAuth: string = "";
  urlIMG: string = "";

  random: number = Math.floor(Math.random() * 100) + 1

  constructor(private router: Router, private http: HttpClient) {
    if (this.productionenvironment) {
      // production
      this.urlService = "https://www.simesccotecnologia.com.co/apiGestionComercial/"
      this.urlHome = "https://www.simesccotecnologia.com.co/gestioncomercial/"
      //SIIGO integration
      this.urlSIIGOAuth = "https://api.siigo.com/auth"
      // url Imagenes
      this.urlIMG = "https://www.simesccotecnologia.com.co/repository/imagenes/"
    } 
    else {
      //test
      this.urlService = "https://localhost:44332/"
     // this.urlService = "https://www.simesccotecnologia.com.co/apiGestionComercial/"
      this.urlHome = "http://localhost:4200/"
      //SIIGO integration
      this.urlSIIGOAuth = "https://api.siigo.com/auth"
      // url Imagenes
      this.urlIMG = "https://www.simesccotecnologia.com.co/repository/imagenes/"
    }

  }

  //verification digit calculation
  getDigitVerification = (string: string): number => {
    let missZero = 15 - string.length;
    let sumType1 = 0;
    //place on 15 positions
    for (let x = 0; x <= missZero; x++) {
      string = '0' + string;
    }
    string.split('').map((row, position: number) => {
      switch (position) {
        case 1:
          sumType1 = sumType1 + (parseInt(row) * 71);
          break;
        case 2:
          sumType1 = sumType1 + (parseInt(row) * 67);
          break;
        case 3:
          sumType1 = sumType1 + (parseInt(row) * 59);
          break;
        case 4:
          sumType1 = sumType1 + (parseInt(row) * 53);
          break;
        case 5:
          sumType1 = sumType1 + (parseInt(row) * 47);
          break;
        case 6:
          sumType1 = sumType1 + (parseInt(row) * 43);
          break;
        case 7:
          sumType1 = sumType1 + (parseInt(row) * 41);
          break;
        case 8:
          sumType1 = sumType1 + (parseInt(row) * 37);
          break;
        case 9:
          sumType1 = sumType1 + (parseInt(row) * 29);
          break;
        case 10:
          sumType1 = sumType1 + (parseInt(row) * 23);
          break;
        case 11:
          sumType1 = sumType1 + (parseInt(row) * 19);
          break;
        case 12:
          sumType1 = sumType1 + (parseInt(row) * 17);
          break;
        case 13:
          sumType1 = sumType1 + (parseInt(row) * 13);
          break;
        case 14:
          sumType1 = sumType1 + (parseInt(row) * 7);
          break;
        case 15:
          sumType1 = sumType1 + (parseInt(row) * 3);
          break;

      }
    })
    if ((sumType1 % 11) <= 1)
      return (sumType1 % 11)
    else
      return 11 - (sumType1 % 11);
  }

  formatDateUnique = (date: Date) => {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear(),
      hour = d.getHours().toString(),
      minute = d.getMinutes().toString();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
    if (hour.length < 2)
      hour = '0' + hour;
    if (minute.length < 2)
      minute = '0' + minute;

    return [year, month, day].join('-');
  }

  addDaysDate = (date: Date, days: number): Date => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }


  urltoFile = (url: string, filename: string, mimeType: string) => {
    if (url.startsWith('data:')) {
      var arr: any = url.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[arr.length - 1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      var file = new File([u8arr], filename, { type: mime || mimeType });
      return Promise.resolve(file);
    }
    return fetch(url)
      .then(res => res.arrayBuffer())
      .then(buf => new File([buf], filename, { type: mimeType }));
  }

  // si quiero cerrar por voluntad propia vendra en true
  closeOfSession = (byMyWill?: boolean) => {
    this.router.navigate(['auth']);
    localStorage.clear();
    if (byMyWill == false)
      // session closing message
      localStorage.setItem('msgCloseSession', 'El tiempo de sesión ha finalizado, favor inicie nuevamente')
  }

  /**
   * Generar el movimiento de scroll
   * @param enlace : elemento
   * @param mobile : si es mobile o desktop
   * @param plusPx : número de pixeles a aumentar
   */
  navegar = (enlace: string, mobile: boolean, plusPx?: number) => {
    const el: any = document.getElementById(enlace);
    window.scrollTo(0, el.offsetTop + (mobile ? el.offsetParent.offsetTop : 0) + (plusPx ?? 0));
  }

  // escuchar los errores globales
  handleError(error: HttpErrorResponse) {
    if (error.status == 401) { this.closeOfSession() }
  }

  getversion = () => {
    /* const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }); */
    const url = this.urlHome + "assets/config/config.json?" + this.random;;
    return this.http.get(url);
  }


}
